import axios, { CancelTokenSource } from 'axios';

export interface ICompanyListBase {
  CMPN_NM: string;
  PK_NM_HASH: string;
  SERVICE_NAME: string;
}

export interface IPublicCompanyList extends ICompanyListBase {
  AVG_SALARY_YY: number;
  ROOKEY_SALARY_YY: number;
}

export interface IListedCompanyList extends ICompanyListBase {
  AVG_SALARY_FSS: number;
  ROOKEY_SALARY_FSS: number;
}

interface IPublicCompanyListResponse {
  data: IPublicCompanyList[];
}

interface IListedCompanyListResponse {
  data: IListedCompanyList[];
}

interface Params {
  pagingIndex?: number;
  pagingNum?: number;
  type?: string;
  order?: string;
  sort?: string;
}

/**
 * 공공기관 조회
 * @param param0
 * @returns
 */
export function getPublicCompanyList(params: Params, source?: CancelTokenSource) {
  const { pagingIndex = 0, pagingNum = 20, type = '', order = 'ASC', sort = 'CMPN_NM' } = params;

  return axios.get<IPublicCompanyListResponse>('/api/company/alioList', {
    cancelToken: source ? source.token : undefined,
    params: {
      alioType: type,
      order,
      sortAlio: sort,
      pagingIndex,
      pagingNum,
    },
  });
}

/**
 * 상장사 조회
 * @param param0
 * @returns
 */
export function getListedCompanyList(params: Params, source?: CancelTokenSource) {
  const { pagingIndex = 0, pagingNum = 20, type = '', order = 'ASC', sort = 'CMPN_NM' } = params;

  return axios.get<IListedCompanyListResponse>('/api/company/fssList', {
    cancelToken: source ? source.token : undefined,
    params: {
      fssType: type,
      order,
      fssSort: sort,
      pagingIndex,
      pagingNum,
    },
  });
}
